import { Address } from 'graphql-api/gql-api-interfaces';

export function getAddressUniqueId(address: Address) {
  return `${address.accountId}-${address.addressId}`;
}
